import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { business } from '../data/site';
import { ui } from '../data/ui';
import { buttonClass } from '../utils/styles';
import { TrustBadges } from './TrustBadges';
interface PageHeaderProps {
  eyebrow: string;
  title: string;
  description: string;
  showActions?: boolean;
}
export function PageHeader({
  eyebrow,
  title,
  description,
  showActions = true
}: PageHeaderProps) {
  const {
    t
  } = useLanguage();
  return <section className="bg-navy-deep" data-id="element-336" data-mp="2tor0j4f2epxo">
      <div className="mx-auto max-w-7xl px-6 py-14 sm:py-20" data-id="element-337" data-mp="38g9oppi2vqs4">
        <p className="text-sm font-semibold text-gold" data-id="element-338" data-mp="38huez2xd0nk6">{eyebrow}</p>
        <h1 className="mt-3 max-w-3xl font-display text-3xl leading-[1.12] text-white sm:text-5xl" data-id="element-339" data-mp="33o9k3jr2c9p7">
          {title}
        </h1>
        <p className="mt-5 max-w-2xl text-lg leading-relaxed text-navy-100" data-id="element-340" data-mp="2fx41wxxnh5bq">{description}</p>
        {showActions ? <div className="mt-8 flex flex-wrap items-center gap-3" data-id="element-341" data-mp="2hz858z0fm482">
            <Link to="/contact" className={buttonClass('gold', 'md')} data-id="element-342" data-mp="2hwvqeupz09z8">
              {t(ui.freeEstimate)}
            </Link>
            <a href={business.phoneHref} className={buttonClass('white', 'md')} data-id="element-343" data-mp="2qra10jzk2wc0">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-344" data-mp="2qtd0rvqig3tx" />
              {business.phoneDisplay}
            </a>
          </div> : null}
        <div className="mt-8 border-t border-white/10 pt-6" data-id="element-345" data-mp="1z15mv32e35j8">
          <TrustBadges tone="dark" data-id="element-346" data-mp="231pjm5j1w74u" />
        </div>
      </div>
    </section>;
}